export const getScroll = (element, speed, direction) => {
  const scroll = () => {
    element.scrollBy(0, direction);
  };
  return () => setInterval(scroll, speed);
};
